export const API_ENDPOINTS = {
    /*Cliente */
    GETCLIENTE: () =>                   `/cliente/informacion`,
    GETCLIENTECRM: () =>                `/cliente/informacioncrm`,
    GETCLIENTECRMMEJ: (lang) =>         `/cliente/informacioncrm-mejorado${lang ? `?lang=${lang}` : ''}`,
    POSTESTADOCUENTA: (inversionid) =>  `/cliente/estadocuentacrm/${inversionid}`,

    /*Configuración */
    GETOPCION: () =>                    `/configuracion/opcion/${opcion}`,
    GETPLAZOSPORPRODUCTO: () =>         `/configuracion/plazosporproducto/${productoid}`,
    GETPRODUCTOS: () =>                 `/configuracion/productos`,
    GETFECHASCORTE: () =>               `/configuracion/fechascorte`,

    /*Cuenta*/
    POSTINICIOSESION: (lang) =>         `/cuenta/iniciosesion${lang ? `?lang=${lang}` : ''}`,
    POSTCERRARSESION: (lang) =>         `/cuenta/cerrarsesion${lang ? `?lang=${lang}` : ''}`,
    POSTOLVIDOCONTRASENA: (lang) =>     `/olvidocontrasena/envio-codigo6${lang ? `?lang=${lang}` : ''}`,
    POSTTOKENOLVIDOCONTRASENA: (codigo, lang) => `/olvidocontrasena/activacion6/${codigo}${lang ? `?lang=${lang}` : ''}`,
    POSTCAMBIARCONTRASENA: (lang) =>    `/olvidocontrasena/informacion6${lang ? `?lang=${lang}` : ''}`,

    POSTACTIVACION: (value) =>          `/olvidocontrasena/activacion/${value}`,
    POSTINFORMACION: (id) =>            `/olvidocontrasena/informacion/${id}`,

    /*Registro */
    POSTREGISTRO: (lang) =>             `/registro${lang ? `?lang=${lang}` : ''}`,
    POSTREGISTROINFO: (params) =>       `/registro/informacion/${params.id}${params.lang ? `?lang=${params.lang}` : ''}`,
    POSTREGISTROENVIOCORREO: () =>      `/registro/enviocorreo/${id}`,
    POSTREGISTROACTIVACION: (params) => `/registro/activacion/${params.codigo}`,
    POSTREGISTROENVIOSMS: (params) =>   `/registro/enviosms/${params.id}${params.lang ? `?lang=${params.lang}` : ''}`,
    POSTREGISTROREENVIOSMS: () =>       `/registro/reenviosms/${id}`,
    POSTREGISTROVALIDACION: (params) => `/registro/validacion/${params.id}`,
    /*Simulador */
    GETCATALOGOPLAZO: () =>             `/proyeccion/plazos`,
    CALCULARSIMULACION: () =>           `/proyeccion/comparar`,
    POST_SOLICITUD_SIMULADOR_AUTH: (lang) => `/cuenta/crear-tarea${lang ? `?lang=${lang}` : ''}`,
    POST_PROYECCION_PDF: (lang) =>          `/proyeccion/comparar/export/pdf${lang ? `?lang=${lang}` : ''}`,
    /*Vista Empresas y Privacidad */
    GET_PORTAL_ENLACES: (lang) =>       `/configuracion/portalenlaces?lang=${lang}`,
    /*Solicitud */
    GETSOLICITUD: () =>                 `/solicitud/${id}`,
    GETSOLICITUDLISTADO: () =>          `/solicitud/listado`,
    POSTSOLICITUDSIMULACION: () =>      `/solicitud/simulacion`,
    POSTSOLICITUDVALIDACION: () =>      `/solicitud/validacion`,
    PUTSOLICITUDINFOPERSONAL: () =>     `/solicitud/informacionpersonal/${id}`,
    PUTSOLICITUDTESTIGO: () =>          `/solicitud/testigo/${id}`,
    PUTSOLICITUDDOMICILIO: () =>        `/solicitud/domicilio/${id}`,
    PUTSOLICITUDACTIVIDADECON: () =>    `/solicitud/actividadeconomica/${id}`,
    PUTSOLICITUDCONYUGE: () =>          `/solicitud/conyuge/${id}`,
    PUTSOLICITUDCONYUGEACTIVIDADECON: () => `/solicitud/conyugeactividadeconomica/${id}`,
    PUTSOLICITUDINFOBANCARIA: () =>     `/solicitud/informacionbancaria/${id}`,
    POSTREFERENCIA: () =>               `/solicitud/referencia/${solicitudid}`,
    DELETEREFERENCIA: () =>             `/solicitud/referencia/${solicitudid}/${id}`,
    POSTBENEFICIARIO: () =>             `/solicitud/beneficiario/${solicitudid}`,
    DELETEBENEFICIARIO: () =>           `/solicitud/beneficiario/${solicitudid}/${id}`,
    POSTENVIARCRM: () =>                `/solicitud/enviarcrm/${id}`,
    POSTADJUNTO: () =>                  `/solicitud/adjunto`,
    POSTABONO: () =>                    `/solicitud/abono`,

}
export const EXTERNAL_URLS = {
    INSTRUCTIVO_ACTIVACION_ES: 'https://sgconsulting.site/pdf/Instructivo%20para%20activar%20cuenta%20-%20Portal%20SG.pdf',
    /*Temp en Español hasta conseguir los PDF actualizados */
    INSTRUCTIVO_ACTIVACION_EN: 'https://sgconsulting.site/pdf/Instructivo%20para%20activar%20cuenta%20-%20Portal%20SG.pdf',
    //INSTRUCTIVO_ACTIVACION_EN: 'https://sgconsulting.site/pdf/instruction-activate-account-EN-placeholder.pdf',
    //TERMINOS_CONDICIONES: 'https://sgconsulting.site/wp-content/uploads/2025/09/terminoscondicionescanalesdigitales.pdf',
    PDF_EMPRESA_ES: 'https://sgconsulting.site/pdf/brochure_SG.pdf',
    PDF_EMPRESA_EN: 'https://sgconsulting.site/pdf/brochure_SG-en.pdf',
    PDF_PRIVACIDAD_ES: 'https://sgconsulting.site/pdf/terminoscondicionescanalesdigitales.pdf',
    PDF_PRIVACIDAD_EN: 'https://sgconsulting.site/pdf/terminoscondicionescanalesdigitales-en.pdf',
    SIMULADOR_PUBLIC_URL: 'https://sgconsulting.site/form/form_SG.html'
};
;
